import { createTheme } from "@mui/material/styles";

// Public site theme - BC nation pink on warm cream, rounded & friendly like the Wix site
const theme = createTheme({
  palette: {
    primary: {
      main: "#F43662",
      dark: "#D92352",
      contrastText: "#fff",
    },
    secondary: {
      main: "#F5863E",
      contrastText: "#fff",
    },
    background: {
      default: "#FAF3EB",
      paper: "#fff",
    },
    text: {
      primary: "#32312F",
      secondary: "#64615E",
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: "Montserrat, Arial, sans-serif",
    button: {
      fontWeight: 800,
      letterSpacing: "0.02em",
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: "10px 22px",
        },
        sizeLarge: {
          padding: "14px 30px",
          fontSize: "0.95rem",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
        },
      },
    },
  },
});

export default theme;
